<template>
  <button
    class="btn primary"
    @click="$emit('click')"
    :class="{ loading: isLoading, disabled: isDisabled || isLoading }"
  >
    <slot v-if="!isLoading" />
  </button>
</template>

<script>
export default {
  name: 'SuccessButton',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
